/* theme.vat-toggle.js — cookie-backed VAT toggle (robust; no-op safe) */
(function(){
  const VAT_COOKIE = 'vat_display'; // cookie name
  const INC = 'inc';
  const EXC = 'exc';
  const COOKIE_DAYS = 365;

  // Cookie helpers
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++){
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length,c.length));
    }
    return null;
  }

  // Primary price application: use vatHelpers if present, otherwise fallback
  function applyModeRoot(root, mode) {
    try {
      if (window.vatHelpers && typeof window.vatHelpers.applyVatModeToNode === 'function') {
        window.vatHelpers.applyVatModeToNode(root, mode);
        return;
      }
    } catch (e) {
      // continue to fallback method
    }

    // Fallback: operate directly on DOM under root (or whole doc if root is null)
    const container = root || document;
    const prices = container.querySelectorAll ? container.querySelectorAll('.f-price') : [];
    prices.forEach(el => setPriceElementMode(el, mode));
  }

  // set single f-price element (kept as before)
  function setPriceElementMode(el, mode){
    if(!el) return;
    const incSpans = el.querySelectorAll('.f-price--inc');
    const excSpans = el.querySelectorAll('.f-price--exc');

    if(mode === INC){
      incSpans.forEach(s => s.style.display = '');
      excSpans.forEach(s => s.style.display = 'none');
    } else {
      incSpans.forEach(s => s.style.display = 'none');
      excSpans.forEach(s => s.style.display = '');
    }

    // unit prices
    const unitInc = el.querySelector('[data-unit-price-inc]');
    const unitExc = el.querySelector('[data-unit-price-exc]');
    if(unitInc && unitExc){
      if(mode === INC){ unitInc.style.display = ''; unitExc.style.display = 'none'; }
      else { unitInc.style.display = 'none'; unitExc.style.display = ''; }
    }

    // VAT label toggle
    const labelInc = el.querySelector('.vat-label--inc');
    const labelExc = el.querySelector('.vat-label--exc');
    if(labelInc && labelExc){
      if(mode === INC){ labelInc.style.display = ''; labelExc.style.display = 'none'; }
      else { labelInc.style.display = 'none'; labelExc.style.display = ''; }
    }
  }

  // apply to whole document (preferred: use vatHelpers.applyVatModeToAll if available)
  function setAllPrices(mode){
    try {
      if (window.vatHelpers && typeof window.vatHelpers.applyVatModeToAll === 'function') {
        window.vatHelpers.applyVatModeToAll(mode);
        return;
      }
    } catch (e) {
      // fallback below
    }
    applyModeRoot(document, mode);
  }

  // initialize toggle UI + behavior (if present). If not present, still apply cookie state.
  function initToggle(){
    const toggle = document.getElementById('vat-toggle');
    const btn = document.getElementById('vat-toggle-btn');

    // Decide initial state: cookie -> server DOM -> default EXC
    let state = getCookie(VAT_COOKIE);
    if(!state){
      // check first price element's visible span (server decided)
      const firstPrice = document.querySelector('.f-price');
      if(firstPrice){
        const incSpan = firstPrice.querySelector('.f-price--inc');
        if(incSpan && window.getComputedStyle(incSpan).display !== 'none') state = INC;
        else state = EXC;
      } else {
        state = EXC;
      }
      setCookie(VAT_COOKIE, state, COOKIE_DAYS);
    }

    // Apply state to the DOM (using vatHelpers or fallback)
    setAllPrices(state);

    // If toggle UI is absent, still expose setVatMode and return
    if(!toggle || !btn) {
      // Ensure global setter exists so other scripts can toggle programmatically
      window.setVatMode = function(mode){
        if(mode !== INC && mode !== EXC) return;
        setCookie(VAT_COOKIE, mode, COOKIE_DAYS);
        setAllPrices(mode);
        document.dispatchEvent(new CustomEvent('vat:changed', { detail: { mode: mode } }));
      };
      return;
    }

    // Sync UI attributes
    toggle.setAttribute('data-state', state);
    toggle.setAttribute('aria-checked', state === INC ? 'true' : 'false');
    btn.setAttribute('aria-pressed', state === INC ? 'true' : 'false');

    // Toggle action
    function toggleState(){
      state = (state === INC) ? EXC : INC;
      setCookie(VAT_COOKIE, state, COOKIE_DAYS);

      // update UI attributes
      toggle.setAttribute('data-state', state);
      toggle.setAttribute('aria-checked', state === INC ? 'true' : 'false');
      btn.setAttribute('aria-pressed', state === INC ? 'true' : 'false');

      // apply
      setAllPrices(state);
      document.dispatchEvent(new CustomEvent('vat:changed', { detail: { mode: state } }));
    }

    // Bind events (click + keyboard)
    toggle.addEventListener('click', function(e){
      toggleState();
    }, { passive: true });

    toggle.addEventListener('keyup', function(e){
      if(e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleState();
      }
    });

    // Global helper for programmatic set
    window.setVatMode = function(mode){
      if(mode !== INC && mode !== EXC) return;
      setCookie(VAT_COOKIE, mode, COOKIE_DAYS);
      toggle.setAttribute('data-state', mode);
      toggle.setAttribute('aria-checked', mode === INC ? 'true' : 'false');
      btn.setAttribute('aria-pressed', mode === INC ? 'true' : 'false');
      setAllPrices(mode);
      document.dispatchEvent(new CustomEvent('vat:changed', { detail: { mode: mode } }));
    };
  }

  // react to variant updates and observe product forms (keeps prices in sync)
  function initVariantObservers(){
    document.addEventListener('variant:changed', function(){
      const state = getCookie(VAT_COOKIE) || EXC;
      setAllPrices(state);
    });

    const productForms = document.querySelectorAll('form[data-product-form], [data-product-single], form[action*="/cart/add"]');
    productForms.forEach(form => {
      try {
        const mo = new MutationObserver(() => {
          const state = getCookie(VAT_COOKIE) || EXC;
          setAllPrices(state);
        });
        mo.observe(form, { childList: true, subtree: true, characterData: true });
      } catch (e) {
        // ignore observer errors for forms we can't observe
      }
    });
  }

  // init on DOM ready
  document.addEventListener('DOMContentLoaded', function(){
    try { initToggle(); } catch (e) { console.warn('[VAT] initToggle error', e); }
    try { initVariantObservers(); } catch (e) { console.warn('[VAT] initVariantObservers error', e); }
  });

})();
